import { render, staticRenderFns } from "./platformIntro.vue?vue&type=template&id=78868cfd&scoped=true&"
import script from "./platformIntro.vue?vue&type=script&lang=js&"
export * from "./platformIntro.vue?vue&type=script&lang=js&"
import style0 from "./platformIntro.vue?vue&type=style&index=0&id=78868cfd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78868cfd",
  null
  
)

export default component.exports